import { SignInOptions } from '@farcaster/miniapp-core/src/actions/SignIn.ts'
import { providers } from 'ethers'

const SIGN_IN_DOMAIN = {
    name: 'Towns Miniapp Sign-In',
    version: '1',
}

const SIGN_IN_TYPES: Record<string, Array<{ name: string; type: string }>> = {
    SignIn: [
        { name: 'nonce', type: 'string' },
        { name: 'issuedAt', type: 'string' },
        { name: 'notBefore', type: 'string' },
        { name: 'expirationTime', type: 'string' },
    ],
}

type SignInTypedData = {
    domain: typeof SIGN_IN_DOMAIN
    types: typeof SIGN_IN_TYPES
    value: {
        nonce: string
        issuedAt: string
        notBefore: string
        expirationTime: string
    }
}

export const buildSignInTypedData = (options: SignInOptions): SignInTypedData => {
    const issuedAt = new Date().toISOString()
    return {
        domain: SIGN_IN_DOMAIN,
        types: SIGN_IN_TYPES,
        value: {
            nonce: options.nonce,
            issuedAt,
            notBefore: options.notBefore ?? '',
            expirationTime: options.expirationTime ?? '',
        },
    }
}

export const enrichDomainWithChainId = async (
    signer: providers.JsonRpcSigner,
    domain: SignInTypedData['domain'],
) => {
    try {
        const chainId = await signer.getChainId()
        if (chainId) {
            return {
                ...domain,
                chainId,
            }
        }
    } catch (error) {
        console.warn('[MiniappPanel:SDK] ⚠️ Unable to detect chainId for sign-in', error)
    }
    return domain
}
